import React from 'react';
import { STORE_URL } from '../constants/site';
type Props = {
  variant?: 'primary' | 'light';
  size?: 'md' | 'lg';
  className?: string;
};
function ChromeGlyph({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 48" className={className} aria-hidden="true" data-id="element-6">
      <circle cx="24" cy="24" r="22" fill="#fff" data-id="element-7" />
      <circle cx="24" cy="24" r="9" fill="#fff" stroke="#4285F4" strokeWidth="3" data-id="element-8" />
      <path fill="#EA4335" d="M24 13h19.2A22 22 0 0 0 5.4 12.3l8.3 14.4A11 11 0 0 1 24 13z" data-id="element-9" />
      <path fill="#34A853" d="M30.5 30 20.9 46.6A22 22 0 0 0 43.6 16H24a11 11 0 0 1 6.5 14z" data-id="element-10" />
      <path fill="#FBBC05" d="M13.7 26.7 4.4 10.4A22 22 0 0 0 20.9 46.6L30.5 30A11 11 0 0 1 13.7 26.7z" data-id="element-11" />
      <circle cx="24" cy="24" r="8" fill="#4285F4" data-id="element-12" />
    </svg>;
}
export function ChromeButton({
  variant = 'primary',
  size = 'lg',
  className = ''
}: Props) {
  const base = 'inline-flex items-center justify-center gap-3 rounded-full font-semibold shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus-visible:ring-4 focus-visible:ring-[#1d9bf0]/30';
  const sizes = size === 'lg' ? 'px-7 py-3.5 text-base' : 'px-5 py-2.5 text-sm';
  const variants = variant === 'primary' ? 'bg-[#1d9bf0] text-white hover:bg-[#1a8cd8]' : 'bg-white text-slate-900 border border-slate-200 hover:bg-slate-50';
  return <a href={STORE_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${sizes} ${variants} ${className}`} data-id="element-13">
      <ChromeGlyph className={size === 'lg' ? 'h-6 w-6' : 'h-5 w-5'} data-id="element-14" />
      Add to Chrome — it's free
    </a>;
}